import type { Field, FieldSpecial } from '../models/Field'

export const createFieldChoice = (field: Omit<Field<'choice'>, 'type'>): Field<'choice'> =>
  Object.freeze({ ...field, type: 'choice' })

export const createFieldMaxDiffSetChoice = (
  field: Omit<Field<'maxDiffSetChoice'>, 'type'>,
): Field<'maxDiffSetChoice'> => Object.freeze({ ...field, type: 'maxDiffSetChoice' })

export const createFieldImageChoice = (
  field: Omit<Field<'imageChoice'>, 'type'>,
): Field<'imageChoice'> => Object.freeze({ ...field, type: 'imageChoice' })

export const createFieldText = (field: Omit<Field<'text'>, 'type'>): Field<'text'> =>
  Object.freeze({ ...field, type: 'text' })

export const createFieldVideo = (field: Omit<Field<'video'>, 'type'>): Field<'video'> =>
  Object.freeze({ ...field, type: 'video' })

export const createFieldChoiceText = (
  field: Omit<Field<'choiceText'>, 'type'>,
): Field<'choiceText'> => Object.freeze({ ...field, type: 'choiceText' })

export const createFieldOther = (): Field<'choiceText'> => createFieldChoiceText({ id: 'other' })

export const createFieldNps = (field: Omit<Field<'nps'>, 'type'>): Field<'nps'> =>
  Object.freeze({ ...field, type: 'nps' })

export const createFieldRanked = (field: Omit<Field<'ranked'>, 'type'>): Field<'ranked'> =>
  Object.freeze({ ...field, type: 'ranked' })

export const createFieldSlider = (field: Omit<Field<'slider'>, 'type'>): Field<'slider'> =>
  Object.freeze({ ...field, type: 'slider' })

export const createFieldNa = (): FieldSpecial<'na'> =>
  Object.freeze({
    id: 'na',
    type: 'special',
  })

export const createFieldNone = (): FieldSpecial<'none'> =>
  Object.freeze({
    id: 'none',
    type: 'special',
  })

export const createFieldSkip = (): FieldSpecial<'skip'> =>
  Object.freeze({
    id: 'skip',
    type: 'special',
  })
